<div class="report-container">
  <div class="outcome">
    <hyperkit-typography variant="h4">Outcome</hyperkit-typography>
    <hyperkit-typography variant="body1">{{huntContext.editor.outcome()}}</hyperkit-typography>
  </div>

<report-text-block 
title="{{huntContext.editor.outcomeDependentField()}}"
[value]="huntContext.editor.outcomeDependent()">
</report-text-block>

<report-text-block 
title="Conclusion"
[value]="huntContext.state.hypothesis()">
</report-text-block>
</div>